/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import Radio from 'backbone.radio';

import HeaderBarView from '@/views/HeaderBarView';
import './AssessmentHeaderView.css';
import ButtonCell from '@/backgrid/ButtonCell';

const AssessmentHeaderView = HeaderBarView.extend({
  className: 'assessment-header-view header-bar-view clearfix',

  initialize() {
    const columns = [
      {
        name: 'assessmentId',
        label: 'Assessment ID'
      },
      {
        name: 'commandName',
        label: 'Command Name'
      },
      {
        name: 'assessmentStatus',
        label: 'Status'
      },
      {
        name: 'assignedCRS',
        label: 'Assigned CRS'
      },
      {
        name: 'assessmentType',
        label: 'Assessment Type'
      },
      {
        label: '',
        name: '',
        headerCell: ButtonCell.extend({
          name: 'Reassign',
          onClick: this.onClickReassign.bind(this),
          buttonClass: 'btn btn-primary btn-md mt-3 ms-auto reassign me-3',
          buttonParentClass: 'd-flex flex-row flex-grow-1 align-self-center'
        }),
        renderable: !!this.options.showReassignBtn
      }
    ].filter((col) => col.renderable !== false);

    this.options.columns = new Backbone.Collection(columns);

    this.listenTo(Radio.channel('assessment'), 'update:header', (key, value) => {
      this.model.set(key, value);
    });
  },

  async onClickReassign(e, model) {
    e.preventDefault();
    this.triggerMethod('reassign', model);
  },

  setAssignedCRS(name) {
    this.model.set('assignedCRS', name);
  }
});

export default AssessmentHeaderView;
